import OnestockOnboardingOverviewContainer from "./OnestockOnboardingOverviewContainer";
import OnestockOnboardingOverviewStore from "./OnestockOnboardingOverviewStore";

export default OnestockOnboardingOverviewStore(OnestockOnboardingOverviewContainer);